module.exports = __webpack_public_path__ + "img/published.7279b21b.svg";